import { render, staticRenderFns } from "./termCondition.vue?vue&type=template&id=ca7df178&scoped=true&"
var script = {}
import style0 from "./termCondition.vue?vue&type=style&index=0&id=ca7df178&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca7df178",
  null
  
)

export default component.exports